import { injectable, inject } from 'inversify';
import type { IPlanRepository } from '@/domain/repositories/IPlanRepository';
import { TYPES } from '@/di/tokens';

@injectable()
export class DeletePlanAction {
  constructor(
    @inject(TYPES.IPlanRepository) private planRepository: IPlanRepository
  ) {}

  async execute(id: number): Promise<void> {
    await this.planRepository.delete(id);
  }
}
